/* eslint-disable prettier/prettier */
import localize from '../../localize';
import { convertStringToArray } from '../../helpers';

export default {
  'taxonomies.Kommune': localize('refinementKommune')
    ? localize('refinementKommune')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Målgruppe': localize('refinementMalgruppe')
    ? convertStringToArray(localize('refinementMalgruppe')).map((x) => x.trim())
    : [],
  'taxonomies.Godkendelsesparagraf': localize('refinementGodkendelsesparagraf')
    ? localize('refinementGodkendelsesparagraf')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Aldersgruppe': localize('refinementAldersgruppe')
    ? localize('refinementAldersgruppe')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Tilbud': localize('refinementTilbud')
    ? localize('refinementTilbud')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Segment': localize('refinementSegment')
    ? localize('refinementSegment')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'taxonomies.Region': localize('refinementRegion')
    ? localize('refinementRegion')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'metadata.ssws_driftsform': localize('refinementDriftsform')
    ? localize('refinementDriftsform')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
  'metadata.ssws_ledig-plats': localize('refinementLedigplads')
    ? localize('refinementLedigplads')
        .replace(/,\s*$/, '')
        .split(',')
        .map((x) => x.trim())
    : [],
};
